import React, { useEffect, useState } from "react";
import { useDataProvider } from "../../api/DataProvider";
import VideoCarouselExamples from "../../api/VideoCarouselExamples";
import Chip from '@mui/material/Chip';
import Paper from "@mui/material/Paper";
import { pDataProvider } from "../../utils/parameters";

import "../../styles/devices/mob_SignDialog.css";

export default function DialogContentExamples(props) {
  const { dialogElements, dialogPosition, setDialogPosition, handleClickChangeLemmaByGloss } = props;
  const { json_data_glosses, json_data_lemma, json_data_sentence, getLemmaByGloss} = useDataProvider();
  const [sentence_selected, setSentence_selected] = useState(undefined);
  const [state, setState] = useState(false);

  
  return (
    <>
      <div className='sig_SignModal_CarouselContainer'>
        <VideoCarouselExamples dialogElements={dialogElements} dialogPosition={dialogPosition} setDialogPosition={setDialogPosition} setSentence_selected={setSentence_selected}/>
      </div>
      <div className="sig_SignModal_Sign">
        {/* {dialogPosition["gloss"] !== undefined ? ( */}
          <>
            <Paper className='sig_SignModal_PaperContent'>
              <div className='sig_SignModal_PaperInfo sig_SignModal_ExamplesContainer'>
                {sentence_selected !== undefined ? (
                  <>
                    <div style={{ display: 'flex'}} className='sig_SignModal_PaperLine'>
                      <div className="sig_SignModal_PaperTitle sig_SignModal_Paper_Title_Body_Inline">Frase:</div>
                      <div className="sig_SignModal_PaperBody">{ json_data_sentence[sentence_selected][pDataProvider.text]}</div>
                    </div>
                  {/* {json_data_sentence[sentence_selected][pDataProvider.label] !=='' ? (
                      <div style={{ display: 'flex'}} className='sig_SignModal_PaperLine'>
                        <div className="sig_SignModal_PaperTitle sig_SignModal_Paper_Title_Body_Inline" style={{marginLeft: '8px'}}>LSE:</div>
                        <div className="sig_SignModal_PaperBody">{ json_data_sentence[sentence_selected][pDataProvider.label]}</div>
                      </div>
                    ) : (
                      <></>
                    )}                   */}
                  <hr className='sig_SignModal_Divider'></hr>                  
                  <div className='sig_SignModal_PaperLine'>
                    <div className="sig_SignModal_PaperTitle sig_SignModal_Paper_Title_Body_Inline">Términos recogidos en Signamed dentro de la frase:</div>
                    <div className="sig_SignModal_PaperBody">
                        {json_data_sentence[sentence_selected][pDataProvider.arr_glosses].map((item, idx) => {
                          const lemma_id = getLemmaByGloss(item)
                          return (
                            <>
                              {" "}
                              <Chip className={`sig_SignModal_LemmaChip ${(dialogPosition['lemma'] === lemma_id) ? "sig_SignModal_LemmaChip_Selected" : ""}`}  label={json_data_lemma[lemma_id]['label']} onClick={handleClickChangeLemmaByGloss(item)}/>
                              {" "}
                            </>
                            

                          );
                        })}
                      </div>
                  </div>
                </>
                ) : (
                  <>
                    <Paper className="sig_SignModal_PaperContent">
                      <div className='sig_SignModal_PaperInfo'>
                        <div className='sig_SignModal_PaperLine'>
                          <div className="sig_SignModal_PaperTitle"> Sin ejemplos registrados</div>
                          <div className="sig_SignModal_PaperBody"> Actualmente no disponemos de ejemplos para el signo seleccionado. </div>
                        </div>
                      </div> 
                    </Paper>
                  </>
                )}
              </div>
            </Paper> 
          </>
        {props.children}
      </div>
    </>
  );
}
